export default {
  RefType: {
    31: 'Phiếu rút tiền Kho bạc',
    34: 'Chuyển khoản kho bạc',
    165: 'Chuyển khoản kho bạc vào tài khoản tiền gửi',
    30: 'Phiếu nộp tiền kho bạc',
    33: 'Chi tiền gửi',
    20: 'Phiếu thu tiền',
    21: 'Phiếu chi tiền',
  },

  ScreenName: {
    TitleForm: 'Tùy chỉnh thêm chứng từ',
    AddVoucher: 'Thêm chứng từ',
  },
};
